import { render } from "./OurClientsSectionComponent.vue?vue&type=template&id=c9839fb2&scoped=true"
import script from "./OurClientsSectionComponent.vue?vue&type=script&lang=js"
export * from "./OurClientsSectionComponent.vue?vue&type=script&lang=js"

import "./OurClientsSectionComponent.vue?vue&type=style&index=0&id=c9839fb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9839fb2"]])

export default __exports__